import React from "react";
import {
  Regions,
  type ComponentProps,
  type PageData,
} from "@enonic/react-components";

import "./omsorgPage.scss";

import Header from "/react4xp/components/shared/Header/Header";
import MainMenu from "/react4xp/components/shared/MainMenu/MainMenu";
import Footer from "/react4xp/components/shared/Footer/Footer";

import type { PageComponentProps } from "./omsorgPage.d";

export const omsorgPage = ({
  data,
  common,
  meta,
  component,
}: ComponentProps<PageData>) => {
  const {
    topLinkTitle,
    topLinkUrl,
    topLinkType,
    topLinkShow,
    linkLogo,
    thema,

    menu,

    footerPhone,
    footerMapLinkTitle,
    footerMapLinkUrl,
    footerMapLinkType,
    showSubscribeForm,
    privacyLinkSubscribeFormUrl,
    subscriptionLinkSubscribeFormUrl,
    titleContactUsLinks,
    contactUsLinks,
    titleAboutUsLinks,
    aboutUsLinks,
    socialMedia,
    linkYellowUrl,
    linkYellowShow,
    linkYellowTitle,
    linkYellowType,
    linkDiakonhjemmetHageUrl,
    linkDiakonhjemmetHageTitle,
    linkDiakonhjemmetHageType,
    linkDiakonhjemmetHageShow,
  } = (data.propsPage as PageComponentProps) ?? {};

  return (
    <>
      <Header
        topLinkTitle={topLinkTitle}
        topLinkUrl={topLinkUrl}
        topLinkType={topLinkType}
        topLinkShow={topLinkShow}
        linkLogo={linkLogo}
        thema={thema}
      />

      <MainMenu menu={menu} homeUrl={linkLogo} />

      <Regions common={common} meta={meta} component={component} />

      <Footer
        phone={footerPhone}
        mapLinkTitle={footerMapLinkTitle}
        mapLinkUrl={footerMapLinkUrl}
        mapLinkType={footerMapLinkType}
        showSubscribeForm={showSubscribeForm}
        privacyLinkSubscribeFormUrl={privacyLinkSubscribeFormUrl}
        subscriptionLinkSubscribeFormUrl={subscriptionLinkSubscribeFormUrl}
        titleContactUsLinks={titleContactUsLinks}
        contactUsLinks={contactUsLinks}
        titleAboutUsLinks={titleAboutUsLinks}
        aboutUsLinks={aboutUsLinks}
        socialMedia={socialMedia}
        linkYellowUrl={linkYellowUrl}
        linkYellowTitle={linkYellowTitle}
        linkYellowType={linkYellowType}
        linkYellowShow={linkYellowShow}
        linkDiakonhjemmetHageUrl={linkDiakonhjemmetHageUrl}
        linkDiakonhjemmetHageTitle={linkDiakonhjemmetHageTitle}
        linkDiakonhjemmetHageType={linkDiakonhjemmetHageType}
        linkDiakonhjemmetHageShow={linkDiakonhjemmetHageShow}
        thema={thema}
      />
    </>
  );
};

omsorgPage.displayName = "Page";
export default omsorgPage;
